import PropTypes from 'prop-types'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
} from '@chakra-ui/react'
import React from 'react'
import RequestOk from './RequestOk'
import RequestError from './RequestError'
import { REPOSITORY } from '../../api/repository/Repository'

export default function RequestStatus({
  isOpen,
  onClose,
  headerProps: { code, title, customColor },
  bodyProps: { body },
}) {
  const data = REPOSITORY.local.company.getUserData()
  const redirectToWsp = () => {
    const win = window.open(
      `https://wa.me/${data.oEmpresa[0].oEjecutivo.TelefonoMovil.replace(
        /\s+/g,
        '',
      )}?text=Tengo%20un%20problema%20en%20la%20plataforma%20empresas`,
    )
    win.focus()
  }
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent backgroundColor={'#EEEEEE'}>
        <ModalCloseButton mt="4px" alignSelf="center" onClick={onClose} />
        <ModalBody>
          {code === 200 ? (
            <RequestOk title={title} customColor={customColor} />
          ) : (
            <RequestError error={title} />
          )}
        </ModalBody>

        {code === 200 ? (
          <ModalFooter>{body}</ModalFooter>
        ) : (
          <div onClick={redirectToWsp}>
            <ModalFooter>{body}</ModalFooter>
          </div>
        )}
      </ModalContent>
    </Modal>
  )
}

RequestStatus.propTypes = {
  bodyProps: PropTypes.shape({
    body: PropTypes.node,
  }),
  headerProps: PropTypes.shape({
    title: PropTypes.string,
    code: PropTypes.number,
    customColor: PropTypes.string,
  }),
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
}
